export default __webpack_public_path__ + "static/media/Flag of Ecuador.17296cb5.gif";